var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { IconButton, Menu, MenuItem, Stack } from "@mui/material";
import * as React from "react";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { LoadingButton } from '@mui/lab';
import { useTranslation } from "react-i18next";
import { useReadOnly } from "../utils/hooks/users/useReadOnly";
var EntityActions = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var _l = React.useState(null), anchorEl = _l[0], setAnchorEl = _l[1];
    var open = Boolean(anchorEl);
    var t = useTranslation().t;
    // A read-only user may not save, delete or duplicate anything.
    var readOnly = useReadOnly();
    var restrictEdit = props.restrictEditPermission || readOnly;
    // Mark the enclosing lock scope (e.g. the settings Outlet container) so its field controls
    // are disabled for read-only users. EntityActions is only rendered on editable/detail
    // screens, so list/filter screens (which render none) are never locked. The marker is
    // removed on unmount, so navigating from a detail screen back to a list clears the lock.
    var rootRef = React.useRef(null);
    React.useEffect(function () {
        var _a;
        if (!readOnly)
            return;
        var scope = (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.closest('[data-readonly-lock-scope]');
        if (!scope)
            return;
        scope.setAttribute('data-readonly-locked', 'true');
        return function () { return scope.removeAttribute('data-readonly-locked'); };
    }, [readOnly]);
    console.log('props', props.data.item);
    var saveLabel = props.data.isNew
        ? (_d = (_b = (_a = props.labels) === null || _a === void 0 ? void 0 : _a.create) !== null && _b !== void 0 ? _b : (_c = props.labels) === null || _c === void 0 ? void 0 : _c.save) !== null && _d !== void 0 ? _d : t('Create new')
        : (_f = (_e = props.labels) === null || _e === void 0 ? void 0 : _e.save) !== null && _f !== void 0 ? _f : t('Save');
    var deleteLabel = (_h = (_g = props.labels) === null || _g === void 0 ? void 0 : _g.delete) !== null && _h !== void 0 ? _h : t('Delete');
    var duplicateLabel = (_k = (_j = props.labels) === null || _j === void 0 ? void 0 : _j.duplicate) !== null && _k !== void 0 ? _k : t('Duplicate');
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var showAdditionalActions = false;
    if ((props.data.canDelete || props.data.canDuplicate) && !restrictEdit) {
        showAdditionalActions = true;
    }
    return (_jsxs(_Fragment, { children: [_jsxs(Stack, __assign({ direction: 'row', ref: rootRef }, { children: [_jsx(LoadingButton, __assign({ startIcon: props.data.isNew ? _jsx(AddIcon, {}) : _jsx(SaveIcon, {}), disabled: (!props.data.isDirty && !props.forceEnableSave) || !props.data.isValid || props.data.isMissing || restrictEdit, loading: props.data.saving, onClick: function () { return props.data.save(); }, id: 'btn-entity-save', variant: 'contained', color: props.data.isNew ? 'primary' : 'secondary' }, { children: saveLabel })), showAdditionalActions &&
                        _jsx(IconButton, __assign({ id: "btn-entity-more", "aria-controls": open ? 'basic-menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: handleClick }, { children: _jsx(MoreVertIcon, {}) }))] })), _jsxs(Menu, __assign({ id: "entity-basic-menu", anchorEl: anchorEl, open: open, onClose: handleClose, MenuListProps: {
                    'aria-labelledby': 'basic-button',
                } }, { children: [props.data.canDuplicate &&
                        _jsx(MenuItem, __assign({ onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, props.data.duplicate()];
                                        case 1:
                                            _a.sent();
                                            handleClose();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, id: 'btn-entity-duplicate' }, { children: duplicateLabel })), props.data.canDelete &&
                        _jsx(MenuItem, __assign({ onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, props.data.remove()];
                                        case 1:
                                            _a.sent();
                                            handleClose();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, id: 'btn-entity-delete' }, { children: deleteLabel }))] })), props.data.renderSnackbars()] }));
};
export default EntityActions;
